module.exports = __webpack_public_path__ + "static/footer-logo-4e8bdb3be679ae4904bccbcaf67f94e7.png";